import { render, staticRenderFns } from "./files-filters-modal.vue?vue&type=template&id=4ec1e2ef&scoped=true"
import script from "./files-filters-modal.vue?vue&type=script&lang=js"
export * from "./files-filters-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec1e2ef",
  null
  
)

export default component.exports